export default "__VITE_ASSET__OGHxnbOG__"